import React from "react";
import { Button, Input } from "reactstrap";
import { RiArrowDownLine, RiArrowUpLine, RiDeleteBinFill } from "@remixicon/react";

export default function ServicePartCard({ item, onRemove, onUpdate, onMoveUp, onMoveDown, isDragging, dragHandlers }) {
  return (
    <div
      className={`item service-part-card ${isDragging ? "dragging" : ""}`}
      draggable="true"
      onDragStart={dragHandlers.onDragStart}
      onDragEnd={dragHandlers.onDragEnd}
      onDragOver={dragHandlers.onDragOver}
      onDrop={dragHandlers.onDrop}
    >
      <div className="align-items-start col-md-12 col-xs-12 row">
        <div className="col-md-10 col-xs-12">
          <Input
            aria-label="Service element title"
            className="service-part-card__title"
            type="text"
            value={item.servicePartTitle || ""}
            onChange={(e) => onUpdate(item.key, { servicePartTitle: e.target.value })}
          />
          <Input
            aria-label="Service element notes"
            className="service-part-card__notes mt-2"
            type="textarea"
            value={item.servicePartNotes || ""}
            placeholder="Notes"
            onChange={(e) => onUpdate(item.key, { servicePartNotes: e.target.value })}
          />
        </div>
        <div className="col-md-2 col-xs-12">
          <Button color="link" className="p-0" onClick={() => onRemove(item.key)}>
            <RiDeleteBinFill color="grey" />
          </Button>
          &nbsp;
          <Button color="link" className="p-0" disabled={!onMoveUp} onClick={onMoveUp} title="Move up">
            <RiArrowUpLine color={onMoveUp ? "grey" : "#ccc"} />
          </Button>
          <Button color="link" className="p-0" disabled={!onMoveDown} onClick={onMoveDown} title="Move down">
            <RiArrowDownLine color={onMoveDown ? "grey" : "#ccc"} />
          </Button>
        </div>
      </div>
    </div>
  );
}
